<template>
  <div class="servers-list">
    <!-- list title -->
    <div class="subtitle servers-list-title">
      Servers
    </div>
    <template v-if="servers.length > 0">
      <!-- title row -->
      <div class="server-row titles-row">
        <span class="field name-field">Name</span>
        <span class="field memory-field">Memory</span>
        <span class="field cpu-field">CPU</span>
        <span class="field streams-field">Streams</span>
        <span class="field status-field">Status</span>
        <!-- <span class="field status-field">Scaling</span> -->
      </div>
      <!-- Servers list -->
      <admin-server-short-info
        v-for="s in servers"
        :key="s.id"
        class="server-row"
        :server="s"
        @selected="$emit('serverSelected', { server: s })"
      />
    </template>
  </div>
</template>

<script>
import AdminServerShortInfo from "@/components/admin/main/common/AdminServerShortInfo.vue";

// @group Admin Page
// Servers list with no-detailed information
export default {
  name: "AdminServersList",
  components: {
    AdminServerShortInfo
  },
  props: {
    // servers list
    servers: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.servers-list {
  display: flex;
  flex-direction: column;
}
.servers-list-title {
  padding-bottom: 0.5em;
}
.server-row {
  display: flex;
  padding-bottom: 0.5em;
}

.field {
  text-align: center;
  font-family: var(--sans-font);
}
.name-field {
  width: 150px;
}
.memory-field {
  width: 200px;
  flex-grow: 1;
}
.cpu-field {
  width: 200px;
  flex-grow: 1;
}
.streams-field {
  width: 150px;
}
.status-field {
  width: 100px;
}

@media only screen and (max-width: 400px) {
  .titles-row {
    display: none;
  }
}
@media only screen and (max-width: 640px) {
  .titles-row {
    font-size: var(--tiny-font-sz);
  }
  .streams-field {
    display: none;
  }
}
</style>
